<template>
    <div class="pt-card">
      <div v-if="scroll" :style="scroll?styleObj:{}"  v-bar>
        <div>
          <slot></slot>
        </div>
      </div>
      <div v-else  >
        <div>
          <slot></slot>
        </div>
      </div>
      <div :class="scroll?'foolter-content':''">
        <slot name="foolter"></slot>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'ptCard',
    props:{
      scroll:{
        type:Boolean,
        detail:false,
      },
      styleObj:{
        type:Object,
        default:()=>{
          return {height:'calc(100vh - 142px)'}
        }
      },
    },
    data() {
      return {}
    },
    mounted() {

    },
    methods: {}
  }
</script>

<style scoped lang="less">
  @import "../../core/diy.less";
  .pt-card{
    background: #fff;
    border-radius: 4px;
    padding-top: 1px;
    .scrollDiv{

    }
    .foolter-content{
      height: 52px;
      border-top: 1px solid @border-color;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

</style>